import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import clsx from "clsx";
export function Card({ children, className }) {
    return _jsx("div", { className: clsx("card p-6", className), children: children });
}
export function CardHeader({ title, subtitle, icon, right, }) {
    return (_jsxs("div", { className: "flex items-start justify-between gap-3 mb-4", children: [_jsxs("div", { className: "min-w-0", children: [_jsxs("div", { className: "flex items-center gap-2 text-slate-900 font-semibold", children: [icon, _jsx("span", { className: "truncate", children: title })] }), subtitle && _jsx("p", { className: "mt-1 text-sm text-slate-500", children: subtitle })] }), right] }));
}
